import { BulkAddProductsToShoppingCartResponse } from '../../store/api';
import { useTranslation } from 'react-i18next';
import { TFunction } from 'i18next';
import { useDispatch } from 'react-redux';
import { useState } from 'react';
import { bulkUpdateToCart } from './bulkUpdateToCart';
import { ListSourceType } from '../../../models/ListSourceType';
import { copyBundleGroupFromListToCartByBundleId } from './copyBundleGroupFromListToCartByBundleId';
import { CopyBundleGroupFromSelectionListByBundleIdRequest } from '../selection-list/copyBundleGroupFromListToListByBundleId';

type GetRequestParams = {
    bundleId: string;
    performChecks: boolean;
    sourceSelectionListId: string;
};

const buildCopyProductsCallback = (
    { bundleId, sourceSelectionListId, performChecks }: GetRequestParams,
    t: TFunction
): (() => Promise<BulkAddProductsToShoppingCartResponse>) => {
    return () => {
        try {
            const body: CopyBundleGroupFromSelectionListByBundleIdRequest = { bundleId, sourceSelectionListId };

            return copyBundleGroupFromListToCartByBundleId({
                body,
                params: {
                    performChecks
                }
            });
        } catch (e) {
            throw new Error(t('notifications.buildAddProductsCallback.error'));
        }
    };
};

type CopyBundleGroupToCartParams = {
    onSuccess: () => void;
};

export const useCopyBundleGroupToCart = ({ onSuccess }: CopyBundleGroupToCartParams) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [isLoading, setLoading] = useState(false);

    return {
        isLoading,
        copyToCartBulk: (sourceSelectionListId: string, bundleId: string, performChecks: boolean) => {
            const apiCallback = buildCopyProductsCallback(
                {
                    bundleId,
                    performChecks,
                    sourceSelectionListId
                },
                t
            );

            return bulkUpdateToCart({
                dispatch,
                setLoading,
                performChecks,
                source: ListSourceType.SELECTION_LIST,
                apiCallback,
                t,
                onSuccess,
                productSelection: undefined
            });
        }
    };
};
